import { render, staticRenderFns } from "./SvgCashbackOfferType.vue?vue&type=template&id=94135132&scoped=true"
import script from "./SvgCashbackOfferType.vue?vue&type=script&lang=js"
export * from "./SvgCashbackOfferType.vue?vue&type=script&lang=js"
import style0 from "./SvgCashbackOfferType.vue?vue&type=style&index=0&id=94135132&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94135132",
  null
  
)

export default component.exports